const allMenuList = [
  {
    key: "1",
    name: 'home',
    cn: "首页",
    en: "Home",
  },
  {
    key: "2",
    name: 'dingdanguanli',
    cn: "订单管理",
    en: "Order Management",
    children: [
      { key: "2-1", name: 'houtaishouye', cn: "后台首页", en: "Yeepay Home" },
      { key: "2-2", name: 'mairudingdan', cn: "买入订单", en: "Buy-In Orders" },
      { key: "2-3", name: 'maichudingdan', cn: "卖出订单", en: "Sell-Out Orders" },
    ],
  },
  {
    key: "3",
    name: 'caiwuguanli',
    cn: "财务管理",
    en: "Financial Management",
  },
  {
    key: "4",
    name: 'shanghutongdaoguanli',
    cn: "商户&通道管理",
    en: "Merchant & Channel Management",
    children: [
      { key: "4-1", name: 'shanghuguanli', cn: "商户管理", en: "Merchant Management" },
      { key: "4-2", name: 'tongdaoguanli', cn: "通道管理", en: "Channel Management" },
    ],
  },
  {
    key: "5",
    name: 'appshebeiguanli',
    cn: "App&设备管理",
    en: "App & Device Management",
    children: [
      { key: "5-1", name: 'appguanli', cn: "App管理", en: "App Management" },
      { key: "5-2", name: 'shebeiguanli', cn: "设备管理", en: "Device Management" },
    ],
  },
  {
    key: "6",
    name: 'zhanghaoguanli',
    cn: "账号管理",
    en: "Account Management",
  },
  {
    key: "7",
    name: 'xitongshezhi',
    cn: "系统设置",
    en: "System Settings",
  },
  {
    key: "8",
    name: 'xitongguanliyuan',
    cn: "系统管理员",
    en: "System Admin",
  },
  {
    key: "9",
    name: 'qita',
    cn: "其他功能",
    en: "Other Functions",
  },
];

const tabListMap = {
  "home": [{ cn: "系统", en: "xitongshouyeshuoing" }],
  "houtaishouye": [{ cn: "系统首页说明", en: "System Dashboard Overview" }],
  "mairudingdan": [
    { cn: "买入中订单", en: "Orders In Purchase" },
    { cn: "成功订单", en: "Successful Orders" },
    { cn: "超时订单", en: "Timeout Orders" },
    { cn: "手动提币", en: "Manual Withdrawal " },
  ],
  "maichudingdan": [
    { cn: "路径介绍", en: "Path introduction" },
    { cn: "全部订单", en: "All Orders" },
    { cn: "等待处理", en: "Awaiting Processing" },
    { cn: "处理中", en: "In Processing" },
    { cn: "人工处理", en: "Manual Processing" },
    { cn: "成功审核", en: "Successful Audit" },
    { cn: "成功订单", en: "Successful Orders" },
    { cn: "驳回订单", en: "Rejected Orders" },
    { cn: "冲正订单", en: "Correction Orders" },
    { cn: "卡单处理", en: "Card Order Processing" },
  ],
  'caiwuguanli': [
    { cn: "路径介绍", en: "Path introduction" },
    { cn: "财务报表", en: "Financial Reports" },
    { cn: "商代核账", en: "Agency Reconciliation " },
    { cn: "商户核账", en: "Merchant Reconciliation" },
    { cn: "返佣记录", en: "Rebate Records" },
    { cn: "流水明细", en: "Transaction Details" },
    { cn: "归集设置", en: "Collection Settings" },
    { cn: "归集记录", en: "Collection Records" },
    { cn: "风控冻结", en: "Risk Control & Freeze" },
    { cn: "内部充提", en: "Internal Deposits & Withdrawals" },
    { cn: "系统扣点", en: "System Deductions" },
  ],
  "shanghuguanli": [
    { cn: "商户分组", en: "Merchant Grouping" },
    { cn: "商户管理", en: "Merchant Management" },
    { cn: "商户管理，费率设置", en: "Merchant Management - Rate Setting" },
    { cn: "商代管理", en: "Agency Management" },
  ],
  "tongdaoguanli": [
    { cn: "买入通道", en: "Buy-In Channel" },
    { cn: "卖出通道", en: "Sell-Out Channel" },
    { cn: "卖出操作字典", en: "Sell-Out Operation Dictionary" },
  ],
  "appguanli": [
    { cn: "语言设置", en: "Language Setting" },
    { cn: "系统消息", en: "System Message" },
  ],
  "shebeiguanli": [
    { cn: "设备类型", en: "Device Types" },
    { cn: "设备管理", en: "Device Management" },
  ],
  "zhanghaoguanli": [
    { cn: "账号分组", en: "Account Grouping" },
    { cn: "系统账号", en: "System Account" },
    { cn: "添加账号分组功能讲解", en: "Add Account Group Function" },
    { cn: "ACB挂卡号流程：挂号前准备", en: "ACB Registration Process: Preparation Before Registration" },
    { cn: "ACB挂卡号流程：挂卡上系统", en: "ACB Card Number Registration Process: Card Registration System" },
    { cn: "VIB挂卡号流程：添加设备", en: "VIB Registration Number Process: Add Device" },
    { cn: "VIB挂卡号流程：挂卡上系统前准备", en: "VIB Card Number Registration Process: Preparation Before Registering The Card On The System" },
    { cn: "VIB挂卡号流程：挂号成功", en: "VIB Registration Process: Registration Successful" },
    {
      cn: "TCB挂卡号流程：添加设备",
      en: "TCB Card Number Registration Process: Add Equipment",
    },
    { cn: "TCB挂卡号流程：挂卡上系统前准备", en: "TCB Card Number Registration Process: Preparation Before Registering The Card On The System" },
    { cn: "TCB挂卡号流程：挂号成功", en: "TCB Card Number Registration Process: Registration Successful" },
  ],
  "xitongshezhi": [
    { cn: "系统设置：修改系统名称及logo", en: "System Settings: Modify The System Name And Logo" },
    { cn: "系统设置：卖出", en: "System Settings: Sell" },
    { cn: "系统设置：买入", en: "System Settings: Buy" },
    { cn: "系统设置：财务", en: "System Settings: Finance" },
    { cn: "银行配置", en: "Bank Configuration" },
    { cn: "支付页域名", en: "Scheduled Tasks" },
    { cn: "定时任务", en: "Scheduled Tasks" },
  ],
  "xitongguanliyuan": [
    { cn: "管理员列表", en: "Admin List" },
    { cn: "权限设置", en: "Permission Settings" },
    { cn: "登录日志", en: "Login Logs" },
    { cn: "操作日志", en: "Operation Logs" },
  ],
  'qita': [
    { cn: "短信日志", en: "SMS Logs" },
    { cn: "系统设置：卖出", en: "Third-Party Collection Logs" },
    { cn: "系统设置：买入", en: "Three Party payment Log" },
    { cn: "系统设置：财务", en: "Payout Blacklist" },
    { cn: "三方代付转换字典", en: "Agent IP" },
  ],
};

export {
  allMenuList,
  tabListMap,
};
